import { Injectable } from '@angular/core';
import { HandlerService } from '../../handlers/handlers.service';
import { MethodsService } from 'src/app/core/http/method.service';
import { environment as params } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SucursalesService extends MethodsService  {
  constructor(_HandlerService: HandlerService, http: HttpClient) {
    super(_HandlerService, http);
    this.setApi((<any>params).api.wp);
  }
  getAllData() {
    return this.get('apimj/sucursales/components/sucursales');
  }
  getOptions() {
    return this.get('apimj/sucursales/components/general_options');
  }
}
